export default __webpack_public_path__ + "static/media/DRIVERLICENSEDOCTORCERTIFICATE.1687d3df.png";